import Library from 'pages/BackOfficePage/BackOfficeCategories/Library/Library';

export default Library;
